export const EVENT_NAME = {
  PARLAY_CARD_CTA_CLICKED: "Parlay Card CTA Clicked"
};

export const MODULE = "same_race_parlay";
